import Vue from 'vue'
import Router from "vue-router";

import DefaultLayout from '../layouts/defaultLayout'
import AuthLayout from '../layouts/authLayout'
import Dashboard from '../pages/dashboard'

/* Authentication */
import Login from '../pages/authentication/login'
import Register from '../pages/authentication/register'

/* Catalog */
import SearchPart from '../pages/catalog/SearchPart'
import VehicleLookUp from '../pages/catalog/VehicleLookUp'
import Compatibility from '../pages/catalog/Compatibility'

/* Research */
import Database from '../pages/research/Database/Database'
import DatabaseAdd from '../pages/research/Database/DatabaseAdd'
import DatabaseAddCombo from '../pages/research/Database/DatabaseAddCombo'
import DatabaseAddBatch from '../pages/research/Database/DatabaseAddBatch'
import Analytics from '../pages/research/Analytics/Analytics'

import {store} from '../store';

// component
Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: {
            name: 'dashboard',
        }
    },
    {
        path: '/dashboard',
        name: "dashboard",
        title: "dashboard",
        component: Dashboard,
        type: "link",
        meta: {
            requiresAuth: true,
            layout: DefaultLayout,
        },
    },
    {
        path: "/catalog/search-part",
        title: "Search Part",
        component: SearchPart,
        type: "link",
        name: 'search-part',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: "/catalog/vehicle-lookup",
        title: "Vehicle Look Up",
        component: VehicleLookUp,
        type: "link",
        name: 'vehicle-look-up',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: "/catalog/compatibility",
        title: "Compatibility",
        component: Compatibility,
        type: "link",
        name: 'compatibility',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: "/research/analytics",
        title: "Analytics",
        component: Analytics,
        type: "link",
        name: 'analytics',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: "/research/database",
        title: "Database",
        component: Database,
        type: "link",
        name: 'database',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: "/research/database/add",
        title: "Database Add",
        component: DatabaseAdd,
        type: "link",
        name: 'databaseAdd',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: "/research/database/add-combo",
        title: "Database Add Combo",
        component: DatabaseAddCombo,
        type: "link",
        name: 'databaseAddCombo',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: "/research/database/add-batch",
        title: "Database Add Batch",
        component: DatabaseAddBatch,
        type: "link",
        name: 'databaseAddBatch',
        meta: {
            requiresAuth: true,
            layout: DefaultLayout
        },
    },
    {
        path: '/authentication/login',
        name: 'Login',
        component: Login,
        meta: {
            title: 'Login | Cuba - Premium Admin Template',
            layout: AuthLayout
        }
    },
    {
        path: '/authentication/register',
        name: 'Register',
        component: Register,
        meta: {
            title: 'Register | Cuba - Premium Admin Template',
            layout: AuthLayout
        }
    }
];

const router = new Router({
    routes,
    base: '/',
    mode: 'history',
    linkActiveClass: "active",
    scrollBehavior() {
        return {x: 0, y: 0}
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.state.authentication.status.loggedIn) {
            next({
                path: '/authentication/login',
                query: {redirect: to.fullPath}
            });
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
